<button class="btn btn-primary" *ngIf="(configuration$ | async)?.formats?.length > 0"
        [innerHTML]="'context-menu.actions.export-item.btn' | translate"
        (click)="$event.preventDefault();openExportModal();">
</button>
